export default {
  name: 'marking--treeMrkType',
};